import React from 'react';
import { Route } from 'react-router-dom';
import Routes from './routes';
import CreerCompte from './creer';
import RecupererLogin from './recuperer-login';
import ChangementResponsableLegal from './changementResponsableLegal';
import { getPath } from '../../utils/router';

const Compte = () => {
    return (
        <>
            <Route
                path={getPath(Routes.subroutes.creer)}
                render={(subProps) => <CreerCompte {...subProps} />}
            />
            <Route
                path={getPath(Routes.subroutes.recupererLogin)}
                render={(subProps) => <RecupererLogin {...subProps} />}
            />
            <Route
                path={getPath(Routes.subroutes.changementResponsableLegal)}
                render={(subProps) => <ChangementResponsableLegal {...subProps} />}
            />
        </>
    );
};

export default Compte;
